import styled from 'styled-components/native';

import { peacock, warrior, white } from '../../../../constants/color';

export default {
  Container: styled.View`
    margin-top: 10px;
    background-color: ${white};
    flex-direction: row;
    padding: 15px 18px 5px 13px;
    align-items: center;
  `,
  Text: styled.Text`
    color: ${warrior};
    font-size: 15px;
    font-weight: 600;
    line-height: 21px;
    margin-left: 2px;
  `,
  Blank: styled.View`
    flex: 1;
  `,
  ClearText: styled.Text`
    color: ${peacock};
    font-size: 13px;
    line-height: 15px;
  `,
};
